(ns ductile.ui.load-builder-v2.hooks
  (:require [ductile.ui.load-builder-v2.commands :as lb2commands]
            [ductile.ui.load-builder-v2.protocol :as lb2protocol]
            [ductile.ui.load-builder-v2.reducer :as lb2reducer]
            [nextjournal.clerk.render.hooks :as hooks]))

(defn use-load-builder-v2-state [{:keys [loads fahrzeuge layout shared]}]
  (let [!state (hooks/use-state (lb2reducer/init-state {:loads loads
                                                        :fahrzeuge fahrzeuge
                                                        :layout layout
                                                        :shared shared}))
        dispatch! (fn [event]
                    (swap! !state lb2reducer/reduce-event event))]
    {:!state !state
     :dispatch! dispatch!}))

(defn use-load-builder-v2-controller [{:keys [commands-args protocol-args]}]
  (let [protocol (hooks/use-memo #(lb2protocol/make-protocol protocol-args)
                                 [(hash protocol-args)])
        commands (hooks/use-memo #(lb2commands/make-commands (assoc commands-args
                                                                    :submit-shared-op! (:submit-shared-op! protocol)))
                                 [(hash commands-args) (hash protocol)])]
    {:commands commands
     :protocol protocol}))
